import {
    createSlice
} from "@reduxjs/toolkit";
import { getNotificationAll, getNotificationUnreadCount } from "./thunk";
export const initialState = {
    notificationAll: [],
    unreadCount: 0,
    error: "", // for error message
    loading: false,
    countLoading: false,
};

const notificationAllSlice = createSlice({
    name: "notificationAll",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getNotificationAll.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getNotificationAll.fulfilled, (state, action) => {
                state.notificationAll = action.payload;
                state.loading = false;
            })
            .addCase(getNotificationAll.rejected, (state, action) => {
                state.error = action.payload ? action.payload?.error : action.error.message;
                state.loading = false;
            })
            .addCase(getNotificationUnreadCount.pending, (state) => {
                state.countLoading = true;
                state.error = null;
            })
            .addCase(getNotificationUnreadCount.fulfilled, (state, action) => {
                state.unreadCount = action.payload.data || 0;
                state.countLoading = false;
            })
            .addCase(getNotificationUnreadCount.rejected, (state, action) => {
                state.error = action.payload ? action.payload?.error : action.error.message;
                state.countLoading = false;
            })
    }
});


export default notificationAllSlice.reducer;